jQuery(($) => {
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser - Keydown Focus Class
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $("body").on("keydown", function () {
        if (!$(".keyboard-in-use")[0]) {
        $(this).addClass("keyboard-in-use");
        }
    });

    $("body").on("mousedown", function () {
        if ($(".keyboard-in-use")[0]) {
        $(this).removeClass("keyboard-in-use");
        }
    });

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Stop Donation
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($(".awana-MyAccount-table .stop-donation")[0]) {
        $(".awana-MyAccount-table .stop-donation").click(function (e) {
            const $modal = $(`#stopDonation`);

            $modal
                .addClass("m-modal--open")
                .attr("tabindex", "1");
        });
    }


});